/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Vymazat filtry`
};

const da_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Ryd filtre`
};

const de_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filter entfernen`
};

const en_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Clear filters`
};

const es_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Eliminar filtros`
};

const fr_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Supprimer les filtres`
};

const hu_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Szűrők törlése`
};

const it_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Rimuovi filtri`
};

const nl_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Filters wissen`
};

const pl_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Wyczyść filtry`
};

const pt_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Limpar filtros`
};

const sv_clear_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Rensa filter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const clear_filters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.clear_filters(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("clear_filters", locale)
	if (locale === "cs") return cs_clear_filters(inputs)
	if (locale === "da") return da_clear_filters(inputs)
	if (locale === "de") return de_clear_filters(inputs)
	if (locale === "en") return en_clear_filters(inputs)
	if (locale === "es") return es_clear_filters(inputs)
	if (locale === "fr") return fr_clear_filters(inputs)
	if (locale === "hu") return hu_clear_filters(inputs)
	if (locale === "it") return it_clear_filters(inputs)
	if (locale === "nl") return nl_clear_filters(inputs)
	if (locale === "pl") return pl_clear_filters(inputs)
	if (locale === "pt") return pt_clear_filters(inputs)
	return sv_clear_filters(inputs)
};